/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DeviceRegistrationRequestDTO } from "./DeviceRegistrationRequestDTO";

export type CreateAccountRequestDTO = {
  businessCategoryId?: number;
  countryCode?: CreateAccountRequestDTO.countryCode;
  deviceRegistrationRequestDTO?: DeviceRegistrationRequestDTO;
  phoneNumber?: string;
};

export namespace CreateAccountRequestDTO {
  export enum countryCode {
    NG = "NG",
    GH = "GH",
  }
}
